export default __webpack_public_path__ + "static/media/perawat.0d441931.svg";